import { render, staticRenderFns } from "./shuangyuXw.vue?vue&type=template&id=0475c5e0&scoped=true"
import script from "./shuangyuXw.vue?vue&type=script&lang=js"
export * from "./shuangyuXw.vue?vue&type=script&lang=js"
import style0 from "./shuangyuXw.vue?vue&type=style&index=0&id=0475c5e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0475c5e0",
  null
  
)

export default component.exports